import { Guid } from "@/types"

export interface IGetGlobalAssetOverviewItemDto {
    articleId: Guid
    assetId: Guid
    lmid: Guid
    holderId: Guid
    yearOfConstruction: number
    isLabeled: boolean
    distance?: number | null
}

export interface IGlobalAssetOverviewInitParams {
    articleDescription?: string
    articleNo?: string
}

export class GlobalAssetOverviewItem {
    articleId: Guid
    assetId: Guid
    lmid: Guid
    holderId: Guid
    yearOfConstruction: number
    isLabeled: boolean
    distance?: number | null
    articleDescription?: string
    articleNo?: string

    constructor(
        dto: IGetGlobalAssetOverviewItemDto,
        { articleDescription, articleNo }: IGlobalAssetOverviewInitParams
    ) {
        this.articleId = dto.articleId
        this.assetId = dto.assetId
        this.lmid = dto.lmid
        this.holderId = dto.holderId
        this.yearOfConstruction = dto.yearOfConstruction
        this.isLabeled = dto.isLabeled
        this.distance = dto.distance
        this.articleDescription = articleDescription
        this.articleNo = articleNo
    }
}
